export const GET_USERS_REQUEST = "GET_USERS_REQUEST";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_FAIL = "GET_USERS_FAIL";

export const GET_BATCH_REQUEST = "GET_BATCH_REQUEST";
export const GET_BATCH_SUCCESS = "GET_BATCH_SUCCESS";
export const GET_BATCH_FAIL = "GET_BATCH_FAIL";

export const UNENROLL_STUDENT_REQUEST = "UNENROLL_STUDENT_REQUEST";
export const UNENROLL_STUDENT_SUCCESS = "UNENROLL_STUDENT_SUCCESS";
export const UNENROLL_STUDENT_FAIL = "UNENROLL_STUDENT_FAIL";

export const ENROLLED_STUDENT_REQUEST = "ENROLLED_STUDENT_REQUEST";
export const ENROLLED_STUDENT_SUCCESS = "ENROLLED_STUDENT_SUCCESS";
export const ENROLLED_STUDENT_FAIL = "ENROLLED_STUDENT_FAIL";

export const ALL_PAYMENT_REQUEST = "ALL_PAYMENT_REQUEST"
export const ALL_PAYMENT_SUCCESS = "ALL_PAYMENT_SUCCESS"
export const ALL_PAYMENT_FAIL = "ALL_PAYMENT_FAIL"

export const ADD_RECC_DATA_REQUEST = "ADD_RECC_DATA_REQUEST"
export const ADD_RECC_DATA_SUCCESS = "ADD_RECC_DATA_SUCCESS"
export const ADD_RECC_DATA_FAIL = "ADD_RECC_DATA_FAIL"

export const DELETE_RECC_DATA_REQUEST = "ADD_RECC_DATA_REQUEST"
export const DELETE_RECC_DATA_SUCCESS = "ADD_RECC_DATA_SUCCESS"
export const DELETE_RECC_DATA_FAIL = "ADD_RECC_DATA_FAIL"

export const UPDATE_RECC_DATA_REQUEST = "ADD_RECC_DATA_REQUEST"
export const UPDATE_RECC_DATA_SUCCESS = "ADD_RECC_DATA_SUCCESS"
export const UPDATE_RECC_DATA_FAIL = "ADD_RECC_DATA_FAIL"

export const GET_ALL_RECC_DATA_REQUEST = "GET_ALL_RECC_DATA_REQUEST"
export const GET_ALL_RECC_DATA_SUCCESS = "GET_ALL_RECC_DATA_SUCCESS"
export const GET_ALL_RECC_DATA_FAIL = "GET_ALL_RECC_DATA_FAIL"

export const CLEAR_ERRORS = "CLEAR_ERRORS";